import { get, reduce } from 'lodash';

export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json'
};

function getNocSessionExpiredUrl() {
    return `${window.getSessionExpiredUrl()}?reason=session`;
}

function getSessionExpiredUrl() {
    return get(window.noc, 'sessionExpiredUrl', getNocSessionExpiredUrl());
}

function getAuthorizationHeader(authorizationKey) {
    const authorizationHeader = {
        Authorization: `Bearer ${authorizationKey}`
    };
    return authorizationHeader;
}

function getHostUrl() {
    const protocol = location.protocol;
    const port = (location.port && location.port.length > 0) ? `:${location.port}` : '';
    return `${protocol}//${location.hostname}${port}/rest`;
}

export function getQueryParamString(queryParams) {
    const queryParamList = reduce(queryParams, (result, value, key) => {
        if (Array.isArray(value)) {
            const arrayKey = key;
            value.map(function(arrayResult, index, value, key) {
                reduce(arrayResult, (keyresult, columnvalue, key) => {
                    const queryStringKey = `${arrayKey}[${index}].${key}`;
                    if (columnvalue !== 0 && !columnvalue) {} else {
                        result.push(`${queryStringKey}=${encodeURIComponent(columnvalue)}`);
                    }
                }, []);
            });
        } else if (value !== 0 && !value) {
            return result;
        } else {
            result.push(`${key}=${encodeURIComponent(value)}`);
        }
        return result;
    }, []);

    if (!queryParamList.length) {
        return '';
    }

    return `${queryParamList.join('&')}`;
}


/**
 * @param resourcePath - the resource path url
 * @param options - method(String) [required] -- [GET|POST|PUT|DELETE|PATCH|OPTION]
 *                  data(Object) -- the request body
 *                  headers(Object) -- { header1: 'val', header2: 'val2' }
 *                                  -- [Content-Type=application/json] by default
 *                  queryParams(Object) -- { page: '1', filter: 'blah' }
 * @return ES6 Promise
 */
function handleErrors(response) {
    return {
        IsError: true,
        Errors: [],
        Message: 'Some error occurred',
        ResponseCode: 10000,
        Description: 'There is some error occurred, we are working towards it.'
    };
}

export function send(resourcePath, options) {
    const url = `${resourcePath}?${
        getQueryParamString(options.queryParams)}`;

    const authorizationHeader = getAuthorizationHeader(options.key);

    const headers = {
        ...DEFAULT_HEADERS,
        ...authorizationHeader
    };
    const body = typeof options.data === 'string' ? options.data : JSON.stringify(options.data);
    const fetchOptions = {
        headers,
        body,
        credentials: 'include',
        method: options.method
    };
    return fetch(url, fetchOptions).then(response => {
        if (response.status === 401) {
            window.location.href = getSessionExpiredUrl();
        }

        if (response.status >= 400 && response.status < 500) {
            const error = new Error(response.statusText);
            error.response = response;
            // handleErrors(response);
            throw error;
        }

        if (response.status >= 500) {
            return handleErrors(response);
        }

        if (response.headers.get('content-type') === 'text/plain') {
            return response.text();
        }

        return response.json();
    }).catch(ex => {
        console.log('parsing failed', ex);
    });
}

export default {
    getHostUrl,
    getQueryParamString,
    delete: (url, options) => send(url, {
        ...options,
        method: 'DELETE'
    }),

    get: (url, options) => send(url, {
        ...options,
        method: 'GET'
    }),

    patch: (url, options) => send(url, {
        ...options,
        method: 'PATCH'
    }),

    post: (url, options) => send(url, {
        ...options,
        method: 'POST'
    }),

    put: (url, options) => send(url, {
        ...options,
        method: 'PUT'
    })
};



// WEBPACK FOOTER //
// ./app/common/request.js